export default function sitesRouteConfig($stateProvider) {
  'ngInject';

  $stateProvider
    .state('sites', {
      url: '/sites',
      template: `<sites-main></sites-main>`,
      redirectTo: 'sites.list',
      ncyBreadcrumb: {
        label: "{{'Sites' | translate}}",
      },
      requiredFeatures: ['sites'],
    })
    .state('sites.list', {
      url: '',
      template: '<sites-list></sites-list>',
      ncyBreadcrumb: {
        skip: true,
      },
    })
    .state('sites.view', {
      url: '/:id',
      template: '<site-view></site-view>',
      ncyBreadcrumb: {
        label: '{{siteName}}',
      },
    });
}
